import React from 'react';
import { useLocation } from 'react-router-dom';
import { useKioskMode } from '../../contexts/KioskModeContext';
import KioskChrome from './KioskChrome';
import KioskFloatingCart from './KioskFloatingCart';

/** Kiosk header + cart FAB when the WebView briefly lands on `/restaurants/...` before redirect. */
const KioskEmbeddedChrome: React.FC = () => {
  const location = useLocation();
  const { enabled, embeddedGuestSurface } = useKioskMode();

  if (!enabled || !embeddedGuestSurface || location.pathname.startsWith('/kiosk/')) {
    return null;
  }

  return (
    <>
      <KioskChrome />
      <KioskFloatingCart />
    </>
  );
};

export default KioskEmbeddedChrome;
